exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".articles-1{fill:#a6b1b9}.articles-2{fill:#fff}.articles-3{fill:#72cac2}.articles-4{fill:#fbe57f}.articles-5{fill:#1e4e69}\n", ""]);
